import { SearchState } from '@reducers/search';
import { GeoLevel, getGeoLevel } from '@sbt-web/networking';
import { AdTypes } from '@sbt-web/networking';
import { CategoryID } from '@sbt-web/network/types';
import { Category } from '@sbt-web/category-utils';
import { adTypesShortLabelsMap } from '@shared/tools/search/values';
import { getVehiclesLabel } from '../../helpers/automotive';
import {
  capitalizeFirst,
  capitalizeOnlyFirst,
  formatWithSpaces,
} from '../../helpers/common';
import { getGeoLabel, SEOTag } from '../../helpers/geo';
import { titleCustomStrings } from './customStrings';

function getCategoryLabel(category: Category): string {
  if (category.id !== CategoryID.Tutte) {
    let categoryLabel = category.label;
    switch (category.id) {
      case CategoryID.AudioVideo: {
        categoryLabel = 'Audio e video';
        break;
      }
      case CategoryID.CasaPersona: {
        categoryLabel = 'Per la casa e per la persona';
        break;
      }
      case CategoryID.SportsHobby: {
        categoryLabel = 'Sport e hobby';
        break;
      }
      case CategoryID.AltriAnnunci:
      case CategoryID.Altri:
        categoryLabel = 'Viaggi, accessori, oggetti';
    }

    return capitalizeOnlyFirst(categoryLabel);
  }
  return 'Gratuiti';
}

export function getTitle(search: SearchState): string {
  const geoLevel = getGeoLevel(search.geo, search.searchNearRegions);
  const categoryLabel = getCategoryLabel(search.category);

  let titleCustomString = titleCustomStrings[search.category.id];
  if (
    search.category.id == CategoryID.Tutte &&
    search.adType &&
    search.adType == AdTypes.VacationRent
  ) {
    titleCustomString = 'case vacanze';
  }

  let adTypeLabel = adTypesShortLabelsMap[search.adType];
  if (
    search.category.id == CategoryID.LavoroServizi ||
    search.category.id == CategoryID.OfferteLavoro ||
    search.category.id == CategoryID.Candidati
  ) {
    adTypeLabel = '';
  }

  let titleChunks: string[] = [];
  let geoLabel = getGeoLabel(
    search,
    geoLevel as GeoLevel & GeoLevel.Italia,
    SEOTag.TITLE_WITH_QUERY
  );

  if (search.query) {
    // Query
    titleChunks = [capitalizeFirst(search.query), '-'];
    titleChunks.push(adTypeLabel);
    if (search.category.id !== CategoryID.Tutte) {
      titleChunks.push('in', categoryLabel);
    }
    titleChunks.push(geoLabel);
  } else {
    // Without Query
    const vehiclesLabel = getVehiclesLabel(search);
    if (
      (search.category.id == CategoryID.Auto ||
        search.category.id == CategoryID.Moto) &&
      vehiclesLabel
    ) {
      titleChunks.push(vehiclesLabel, geoLabel);
    } else {
      geoLabel = getGeoLabel(
        search,
        geoLevel as GeoLevel & GeoLevel.Italia,
        SEOTag.TITLE
      );
      const regionLabel =
        geoLevel !== GeoLevel.Italia
          ? search.searchNearRegions
            ? geoLabel
            : search.geo.region.value
          : '';
      titleChunks.push(
        'Annunci',
        categoryLabel,
        geoLabel,
        '-',
        adTypeLabel,
        titleCustomString,
        regionLabel
      );
    }
  }

  // Add Pagination
  if (search.page && search.page > 1) {
    titleChunks.push('-', search.page.toString());
  }

  titleChunks.push('-', 'Subito.it');

  return formatWithSpaces(...titleChunks);
}
